<template>
    <div>
        <a-card size="small">
            <a-spin tip="Cargando sesion activa" :spinning="loading">
                <a-form>
                    <g-dropdown :label="$t('Encuestas Disponibles')"
                                :formItemConfig="fiOptions"
                                endpoint="encuestas"
                                :selectedObj.sync="encuestaSeleccionada"
                    ></g-dropdown>
                    <a-form-item :wrapper-col="{ span: 18, offset: 6 }"
                                 v-if="encuestaSeleccionada.value && !sesionActiva && !loading">

                        <a-button type="primary" @click="registrarSesion" class="encBtn">
                            Iniciar Encuesta<a-icon type="right" />
                        </a-button>
                    </a-form-item>
                </a-form>
            </a-spin>
            <span v-if="encuestaSeleccionada.value && !sesionActiva.id && !loading">
            <a-alert type="success" showIcon>
              <span slot="message"
                    v-html="$getConfigValue('MENSAJE_INICIO_ENCUESTA','Ahora puede iniciar la encuesta.')">
              </span>
            </a-alert>
            </span>
            <span v-else-if="!encuestaSeleccionada.value && !loading">
            <a-alert type="warning" showIcon>
              <span slot="message"
                    v-html="$getConfigValue('MENSAJE_SELECCION_ENCUESTA','Seleccione una encuesta para comenzar.')">
              </span>
            </a-alert>
        </span>
        </a-card>
        <a-row>&nbsp;</a-row>
        <encuesta-component :encuesta_id="encuestaSeleccionada.value"
                            :fill_out_id="sesionActiva.id"
                            v-if="encuestaSeleccionada.value && sesionActiva.id"></encuesta-component>
    </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        encuestaSeleccionada: {
          status: 1
        },
        sesionActiva: '',
        loading: false,
        fiOptions: {
          'label-col': {span: 6},
          'wrapper-col': {span: 18},
          'has-feedback': true,
          'class': 'evaluaciones'
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      registrarSesion () {
        this.loading = true
        this.httpClient.getInstance().post('encuestas/fill_out/registra_sesion/' + this.encuestaSeleccionada.value)
          .then(response => {
            this.sesionActiva = response.data
          })
          .catch(error => {
            Mensajes.error('Error', 'No fue posible registrar una nueva sesion para la encuesta seleccionada.')
          })
          .then(() => {
            this.loading = false
          })
      }
    },
    watch: {
      encuestaSeleccionada () {
        if (this.encuestaSeleccionada.value) {
          this.loading = true
          this.httpClient.getInstance().get('encuestas/fill_out/consulta_sesion_activa/' + this.encuestaSeleccionada.value)
            .then(response => {
              if (JsUtils.isEmpty(response.data)) {
                this.sesionActiva = false
              } else {
                this.sesionActiva = response.data
              }
            })
            .catch(error => {
              Mensajes.error('Error', 'No fue posible consultar la sesion activa para la encuesta seleccionada.')
            })
            .then(() => {
              this.loading = false
            })
        }
      }
    }
  }
</script>
<style>
    .encBtn{
        background-color: #ff7818;
        border-color: #ff9818;
    }

    .encBtn:hover{
        background-color: #ffbb40;
        border-color: #ffaa40;
    }

    .ant-btn-group .encBtn:last-child:not(:first-child), .ant-btn-group .encBtn + .encBtn{
        border-left-color: #ff9818;
    }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Encuesta/Encuesta.vue